/* eslint-disable no-console */
import {LoginOutlined} from '@ant-design/icons';
import {Result, Button, Card, Row, Col, Typography} from 'antd';
import React from 'react';
import {useSearchParams} from 'react-router-dom';

import FullLogo from '../../assets/FullLogo.svg';

const AuthError: React.FC = () => {
  const [searchParams] = useSearchParams();

  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description') ?? '';

  const title = error ? `Error: ${error}` : 'Authentication Failed';

  const {Title, Text} = Typography;

  return (
    <>
      <Row justify="start" align="middle">
        <Col className="form-col" xs={12} md={12} lg={12}>
          <div className="form-wrapper">
            <div className="form-header">
              <img
                src={FullLogo}
                alt="Bharat Carbon"
                style={{
                  width: '122px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                  paddingTop: '10px',
                  paddingLeft: '10px'
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="signup-row" justify="center" align="middle">
        <Col className="form-col" xs={12} md={12} lg={12}>
          <div className="form-wrapper">
            <div
              style={{
                padding: '40px',
                maxWidth: 1000,
                margin: '0 auto'
              }}
            >
              <Card>
                <Result
                  status="error"
                  title={
                    <Title level={2} style={{marginBottom: 8}}>
                      {title}
                    </Title>
                  }
                  subTitle={
                    <Text style={{fontSize: 17}}>
                      {errorDescription ?? 'Something went wrong!!'}
                    </Text>
                  }
                  extra={[
                    <Button
                      key="login"
                      type="primary"
                      icon={<LoginOutlined />}
                      onClick={() => {
                        window.location.href = '/';
                      }}
                    >
                      Back to Login
                    </Button>
                  ]}
                />
              </Card>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AuthError;
